import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { FormattedDate, FormattedMessage } from 'react-intl'

const now = moment()

const OpenHomeLabel = ({ property }) => {
  const openHomes = _.get(property, 'attributes.settings.open_homes') || []
  const auction = _.get(property, 'attributes.settings.auction')

  // sort the events by start date
  const events = _.orderBy(
    [auction, ...openHomes].filter((event) => !!event?.start_date),
    ['start_date'],
    ['asc']
  )
  const event = _.find(events, (event) => moment(event.start_date).isAfter(now))

  if (event) {
    return (
      <time className="c-openhome-inline">
        {event.end_date ? (
          <FormattedMessage id="open-homes.next-open-home" />
        ) : (
          <FormattedMessage id="open-homes.auction" />
        )}{' '}
        <FormattedDate value={event.start_date} />
      </time>
    )
  }

  return null
}

export default OpenHomeLabel
